import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { commentInit } from '../../../store/reducers/actions/commentInit';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { IGetState } from '../../../../../../../../types/types';

export const onCancel = (): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState,
) => {
        dispatch(commentInit());
        dispatch(segmentTrackAction(SegmentCardEvent.CLICKED_CANCEL_ON_COMMENT, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));
    };
};
